import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorContentModeButton = LoadableAfterPaint({
	loader: async () => {
		const { EditorContentModeButton } = await import(
			/* webpackChunkName: "loadable-EditorContentModeButton" */ '../src/components/EditorContentModeButton.tsx'
		);
		return EditorContentModeButton;
	},
});
